var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fw-switcher",class:_vm.wrapperClass,on:{"click":_vm.toggleSwitch}},[_c('div',{staticClass:"fw-switcher__slider"},[_c('span',{staticClass:"fw-switcher__circle"},[(_vm.isRequestSending)?_c('FwRoundLoader',{attrs:{"size":16}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }